import { clsx } from "clsx"

import { Icon, type IconProps } from "../Icon"
import styles from "./CircleIcon.module.css"

export interface CircleIconProps {
  color?: "grey" | "purple" | "tomato"
  name: IconProps["name"]
  size?: IconProps["size"]
  sx?: IconProps["sx"]
  variant?: "soft" | "solid"
}

export function CircleIcon(props: CircleIconProps) {
  const { color = "grey", name, size = "small", sx, variant = "soft" } = props
  const iconColor = variant === "solid" ? "white" : `${color}11`

  return (
    <div
      className={clsx(
        styles.circleIcon,
        styles[`color-${color}`],
        styles[`size-${size}`],
        styles[`variant-${variant}`]
      )}
      style={sx}
    >
      <Icon color={iconColor} name={name} size={size} />
    </div>
  )
}
